<ng-container *transloco="let t;">

<!-- Product Table Add From Products Modal Start -->

    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Heading text (Product table modal) - Add from products")}}</h4>
        <button type="button" class="close" (click)="activeModal.close()" aria-label="Close-">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="productTable-add-library-modal-body">
            <div class="catalog-left-box position-relative">
                <div *ngIf="!productLibraryItemListingAppend">
                    <div class="mb-75 mt-75 px-1 addToListHeaderArea" *ngIf="checkedProducts.length > 0">
                        <div class="addToListCheckBox">
                            <div class="custom-control custom-control-success custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="checkAllProducts" (change)="checkAllProducts($event)"/>
                                <label class="custom-control-label" for="checkAllProducts"><span>{{checkedProducts.length}}</span> {{t("Item selected text (Product table modal) - item selected")}}</label>
                            </div>
                        </div>
                        <div class="addToListBtn">
                            <button type="button" class="btn btn-success" rippleEffect (click)="selectCheckedProducts()">{{t("Add to list text (Product table modal) - Add to list")}}</button>
                        </div>
                    </div>

                    <div class="input-group input-group-merge mb-75 mt-75 px-1" *ngIf="checkedProducts.length === 0">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon-search2"><i data-feather="search"></i></span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            aria-label="Search products"
                            aria-describedby="basic-addon-search2"
                            [placeholder]="t('Search - label (general) - Search - title')"
                            (keydown.enter)="fetchProducts(1,$event.target.value)"
                        />
                    </div>
                    
                    <app-skeleton *ngIf="!isRecordFetched" [loop]="7" [section]="'document_type'"></app-skeleton>
                    <ng-container *ngIf="isRecordFetched && productsData.length > 0">
                          <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="addProductItemListing_UltScroll">
                              <ul class="addProductItemListing_Ul">
                                  <li class="addProductItemListing_Li" *ngFor="let item of productsData; let i = index" (click)="selectProduct(item)">
                                      <div class="innerBox innerBoxFirst">
                                          <i class="fa fa-tag icon" aria-hidden="true" [ngClass]="{ 'hidden': checkedProducts.includes(item.id) }"></i>
                                          <div class="productItemlistCheckBox" [ngClass]="{ 'v-visible': (checkedProducts.indexOf(item.id) > -1) }">
                                              <div class="custom-control custom-control-success custom-checkbox">
                                                  <input type="checkbox" class="custom-control-input" [id]="'customCheck'+item.id" (click)="$event.stopPropagation()" [checked]="checkedProducts.includes(item.id)" (change)="checkProduct($event, item.id)" />
                                                  <label class="custom-control-label" [for]="'customCheck'+item.id" (click)="$event.stopPropagation()"></label>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="innerBox">
                                          <p class="addProductItemListing_Li_paraOne">{{item.name}}</p>
                                          <p class="addProductItemListing_Li_paraTwo">{{item.sku}}</p>
                                          <p class="addFromProductLibrarySelectedItemsPrice">
                                              <span></span>{{item.price}}<span class="margin-left-5"> {{item.currency}} / {{billingFrequencyLabels[item.billing_frequency]}}</span>
                                          </p>
                                      </div>
      
                                      <span (click)="goToDetailFields($event, item)">
                                          <i data-feather="info" [size]="22" class="text-body icon pe-info"></i>
                                      </span>
                                  </li>
                              </ul>
                          </ng-scrollbar>
                        <ngb-pagination class="d-flex justify-content-end align-items-center mt-2 me-1" (pageChange)="fetchProducts($event)" [collectionSize]="pagination?.total"
                                                    [(page)]="page" [maxSize]="3" aria-label="Default pagination">
                            <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
                                    [size]="18" [class]="'fw-bolder'"></span>
                            </ng-template>
                            <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'"
                                    [size]="18" [class]="'fw-bolder'"></span></ng-template>
                        </ngb-pagination>
                    </ng-container>
                    <div class="noItemAddedBox" *ngIf="isRecordFetched && productsData.length === 0">
                        <p class="paraOne">
                            {{t("No item found text (Product table modal) - No item found")}}
                        </p>
                    </div>
                </div>

                <div id="productlibraryitemdetails" class="product-list-fields mt-75" *ngIf="productLibraryItemListingAppend"> 
                    <div class="mb-1 d-flex align-items-center justify-content-between">
                        <div class="breadcrumb-wrapper d-flex ps-1">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item" (click)="goToProductsListing()">
                                    <a href="javascript:void(0)" class="">Products Listing </a>
                                </li>
                                <li class="breadcrumb-item">
                                    <span class="">{{productDetails.name}}</span>
                                </li>
                            </ol>
                        </div>
                        <div class="d-flex align-items-center pe-1">
                            <i data-feather="plus-square" [size]="16" class="ms-0 text-success"></i>
                            <p class="cursor-pointer text-success fw-bold d-inline m-0 ps-50" (click)="selectProduct(productDetails)">Add to list</p>
                        </div>
                    </div>  
                    
                    <div class="product-list-fields-container">
                        <div class="form-group px-1">
                            <label class="col-form-label pt-0 pb-0" for="productName">{{t("Product form Name field (Product library) - Product Name")}}</label>
                            <input type="text" class="form-control" id="productName" readonly [value]="productDetails.name" />
                        </div>

                        <div class="form-group px-1">
                            <label class="col-form-label pt-0 pb-0" for="productSKU">{{t("Product form SKU field (Product library) - SKU")}}</label>
                            <input type="text" class="form-control" id="productSKU" readonly [value]="productDetails.sku" />
                        </div>
                                
                        <div class="form-group px-1">
                            <label class="col-form-label pt-0 pb-0" for="productPrice">{{t("Product form Price field (Product library) - Price")}}</label>
                            <input type="text" class="form-control" id="productPrice" readonly [value]="productDetails.price" />
                        </div>
                        <div class="form-group px-1">
                            <label class="col-form-label pt-0 pb-0" for="productDesc">{{t("Product form Description field (Product library) - Description")}}</label>
                            <textarea class="form-control" id="productDesc" rows="4" readonly>{{productDetails.description}}</textarea>
                        </div>
                    </div>
                 </div>
            </div>

            <div class="catalog-right-box">
                <div id="producLibrarySelectedItemList" *ngIf="selectedProducts.length > 0">
                    <div class="productSelectedItemHeader listingselecteditemsdiv">
                        <span class="SelectedItemsheadertext">{{selectedProducts.length}} {{t("Item added text (Product table modal) - items added")}}</span>
                        <button type="button" class="btn btn-danger productSelectedItemDeleteBtn" (click)="deletedSelectedItem(-1)">
                            <i data-feather="trash" [size]="14" class="me-25"></i>
                            {{t("Delete items text (Product table modal) - Delete Items")}}
                        </button>
                    </div>
                    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="addProductItemListing_UltScroll">
                        <ul class="addProductItemSelectedListing_Ul">
                            <li class="addProductItemSelectedListing_Li" *ngFor="let item of selectedProducts; let i = index">
                                <div class="innerBox innerBoxFirst" (click)="deletedSelectedItem(i)">
                                    <i class="fa fa-tag icon" aria-hidden="true"></i>
                                    <i data-feather="trash" [size]="18" class="ms-0 deletecurrentitefromlog"></i>
                                </div>
                                <div class="innerBox">
                                    <p class="addProductItemSelectedListing_Li_paraOne">{{item.name}}</p>
                                    <p class="addProductItemSelectedListing_Li_paraTwo">{{item.sku}}</p>
                                    <p class="addFromProductLibrarySelectedItemsPrice mt-25">
                                        <span></span>{{item.price}}<span class="margin-left-5"> {{item.currency}} / {{billingFrequencyLabels[item.billing_frequency]}}</span>
                                    </p>
                                    <div class="input-group bootstrap-touchspin">
                                        <span class="input-group-btn">
                                            <button class="btn btn-default bootstrap-touchspin-down px-75 font-medium-3" type="button" (click)="updateQty('minus',i)">-</button>
                                        </span>
                                        <span class="input-group-addon bootstrap-touchspin-prefix" style="display: none;"></span>
                                        <input type="text" class="form-control" readonly data-plugin="TouchSpin" bdata-min="-1000000000" data-max="1000000000" data-stepinterval="50" data-maxboostedstep="10000000" value="{{item.qty}}" style="display: block;"><span class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span>
                                        <span class="input-group-btn">
                                            <button class="btn btn-default bootstrap-touchspin-up px-75 font-medium-3" type="button" (click)="updateQty('plus', i)">+</button>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </ng-scrollbar>

                    <div class="addFromProductLibraryFooter">
                        <div class="row m-0">
                            <div class="col-md-6 ps-0" style="visibility: hidden;">
                                <p class="addFromProductLibraryFooterItems">{{selectedProducts.length}} {{t("Items total text (Product table modal) - items total")}}</p>
                                <p class="addFromProductLibraryFooterItemsPrice mb-75">{{totalPrice}}</p>
                            </div>
                            <div class="col-md-6">
                                <button type="button" class="btn btn-success me-1 addToProductTablePopupBtn" (click)="addProductsToBlock()" rippleEffect> {{ t("Add to product table button label (Product table modal) - Add to product table") }} </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="noItemAddedBox" *ngIf="selectedProducts.length === 0">
                    <i class="fa fa-tag icon" aria-hidden="true"></i>
                    <p class="paraOne">
                       {{t("No items text (Product table modal) - No items added")}}
                    </p>
                    <p class="paraTwo">
                       {{t("select items text (Product table modal) - Select items from the product list to add them to the product table")}}
                    </p>
                </div>
            </div>
        </div>
    </div>

<!-- / Product Table Add From Products Modal End -->
</ng-container>